// extracted by mini-css-extract-plugin
export default {"primary":"base-button_primary__wbShp","primary_cancel":"base-button_primary_cancel__47lqW","secondary":"base-button_secondary__TXGoa"};